import { render } from "./double_image_edit_modal.vue?vue&type=template&id=6610ef5b"
import script from "./double_image_edit_modal.vue?vue&type=script&lang=ts"
export * from "./double_image_edit_modal.vue?vue&type=script&lang=ts"
script.render = render

export default script